import { cn } from "@/lib/helpers/cn";
import type { ComponentProps } from "react";

import ExternalIcon from "@/assets/images/icons2/icon--external-link.svg";

type LinkProps = ComponentProps<"a"> & {
  isExternal?: boolean;
};

export function Link2({ className, children, isExternal, ...linkProps }: LinkProps) {
  return (
    <a
      className={cn(
        "tw:text-text-teal-primary!",
        !linkProps.href && "tw:cursor-pointer",
        className,
      )}
      {...(isExternal && { target: "_blank", rel: "noopener noreferrer" })}
      {...linkProps}
    >
      {children}
      {isExternal && <img alt="" className="tw:ml-2 tw:align-text-top!" src={ExternalIcon} />}
    </a>
  );
}
